<!--
 * @Author: lll
 * @Date: 2022-11-11 09:28:07
 * @LastEditTime: 2022-11-11 16:23:34
 * @Last Modified by: lll ol
-->
<template>
	<div v-if="renderComponent" id="mapId" class="map">
		<span class="trackNum">{{ trackNum }}</span>
	</div>
</template>
<script>
import "ol/ol.css";
import Map from "ol/Map";
import OSM from "ol/source/OSM";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import {Fill, Style} from "ol/style";

export default {
	props: {
		locationList: Array,
		trackNum: [String, Number]
	},
	name: "olMap",
	data() {
		return {
      renderComponent: true,
			map: "",
			coordinates: [],
			animating: false,
		};
	},
  watch: {
    locationList() {
      this.forceRerender();
    }
  },
	methods: {
    async forceRerender() {
      // remove from the DOM
      this.renderComponent = false;
      // Wait for the change to get flushed to the DOM
      await this.$nextTick();
      this.renderComponent = true;

      setTimeout(function () {
        this.coordinates = this.locationList.map((item) => {
          item = ol.proj.transform(item, "EPSG:4326", "EPSG:3857");
          return item;
        });
        this.initMap();
      }.bind(this), 200);
    },
		initMap() {
			this.map = new Map({
				target: "mapId",

				layers: [
					new TileLayer({
						source: new OSM(),
					}),
				],
				view: new View({
					center: [9.82336521, 52.55749941],
					zoom: 10,
					constrainResolution: false,
					smoothResolutionConstraint: false,
				}),
			});
			this.addPoint(this.coordinates[0], "start");
			this.addPoint(this.coordinates[this.coordinates.length - 1], "end");
			this.addLine();

			this.addPoint(this.coordinates[0], "start");
			this.addPoint(this.coordinates[this.coordinates.length - 1], "lastEnd");
		},
		addPoint(geom, type) {
			let feature = new Feature({
				type: "icon",
				title: "test",
				geometry: new Point(geom),
			});
			// address2
			let img = require(`@/assets/img/trackPay/${
				type === "start" ? "gis_icon_qidian" : "map_address"
			}.png`);
			if (type === "start" || type === "end") {
				feature.setStyle(
					new Style({
						image: new ol.style.Circle({
							radius: 6,
							fill: new Fill({
								color: "#333",
							}),
						}),
					})
				);
			} else {
				feature.setStyle(
					new Style({
						image: new ol.style.Icon({
							src: img,
							rotateWithView: true,
							width: 10,
							height: 10,
							scale: 1,
							anchor: [0.5, 0],
							anchorOrigin: "bottom-left",
							anchorXUnits: "fraction",
							anchorYUnits: "fraction",
						}),
					})
				);
			}

			if (type === "mark") {
				this.geoMarker = feature;
			}
			let source = new VectorSource();
			source.addFeature(feature);
			let layer = new VectorLayer();
			layer.setSource(source);
			this.map.addLayer(layer);
		},
		addLine() {
			let featureLine = new Feature({
				geometry: new LineString(this.coordinates),
			});
			featureLine.setStyle(
				new Style({
					stroke: new ol.style.Stroke({
						width: 6,
						color: "#409EFF",
						// lineDash: [5, 10, 5, 10],
					}),
				})
			);
			let source = new VectorSource();
			source.addFeature(featureLine);
			let layer = new VectorLayer();
			layer.setSource(source);
			this.map.addLayer(layer);
			var extent = layer.getSource().getExtent();
			this.map.getView().fit(extent, {
				duration: 100,
				callBack: null,
				padding: [50, 50, 50, 50],
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.map {
	width: 700px;
	height: 500px;
	position: relative;
	.trackNum {
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1;
		background-color: #fff;
		padding: 5px 20px;
		font-weight: 500;
	}
}
.ol-attribution {
	display: none;
}
</style>
